import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Header from "../Components/Header";
import "./EditProduct.css";
import axios from "axios";
import { API_BASE, FILE_BASE } from "../config";

const EditProduct = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [showPopup, setShowPopup] = useState(false);

  const [product, setProduct] = useState({
    id: "",
    name: "",
    category: "",
    subcategory: "",
    originalPrice: "",
    discountPercentage: "",
    finalPrice: "",
    description: "",
    material: "",
    stock: "",
    image: "",
    images: [],
    status: "Active",
  });

  const [selectedImageIndex, setSelectedImageIndex] = useState(null);


  // ✅ Load Product Data
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(
          `${API_BASE}/Products/${id}`
        );

        const data = response.data;
        console.log(data, "data")

        setProduct({
          id: data.id,
          name: data.name || "",
          categoryId: data.categoryId || "",
          category: data.category?.name || "",
          subcategory: data.subCategory || "",

          originalPrice: data.originalPrice || data.price || 0,

          discountPercentage: data.discountPercentage || 0,

          finalPrice: data.price || 0,

          description: data.description || "",

          material: data.material || "",

          stock: data.quantity || 0,

          sku: data.sku || "",

          weight: data.weight || "",

          size: data.size || "",

          status: data.status || 1,

          images: data.images || [],

          colors: data.colors || [],
        });
      } catch (error) {
        console.error("Error fetching product", error);
      }
    };

    fetchProduct();
  }, [id]);

  useEffect(() => {
    const original = Number(product.originalPrice || 0);

    const discount = Number(product.discountPercentage || 0);

    const final =
      original - (original * discount) / 100;

    setProduct((prev) => ({
      ...prev,
      finalPrice: final,
    }));
  }, [product.originalPrice, product.discountPercentage]);

  // ✅ Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setProduct({
      ...product,
      [name]:
        name === "status"
          ? Number(value)
          : value,
    });
  };

  // ✅ Image Upload
  const handleImageUpload = async (e, index) => {
    try {
      const file = e.target.files[0];

      if (!file) return;

      const formData = new FormData();

      formData.append("file", file);

      const response = await axios.post(
        `${API_BASE}/Upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const imageUrl =
        response.data.imageUrl || response.data.url;

      const updatedImages = [...product.images];

      updatedImages[index] = {
        imageUrl,
        isMain: index === 0,
        imageType: "Product",
      };

      setProduct((prev) => ({
        ...prev,
        images: updatedImages,
      }));

    } catch (error) {
      console.error(error);

      alert("Image upload failed");
    }
  };

  // ✅ SAVE WITH POPUP + AUTO REDIRECT
  const handleSaveClick = async () => {
    try {
      const payload = {
        name: product.name,
        description: product.description,

        categoryId: Number(product.categoryId),

        subCategory: product.subcategory,

        originalPrice: Number(product.originalPrice),

        discountPercentage: Number(product.discountPercentage),

        price: Number(product.finalPrice),

        quantity: Number(product.stock),

        sku: product.sku,

        weight: Number(product.weight),

        material: product.material,

        size: product.size,

        status: Number(product.status),

        images: product.images.map((img, index) => ({
          imageUrl: img.imageUrl || img,
          isMain: index === 0,
          imageType: "Product",
        })),

        colors: product.colors || [],
      };

      await axios.put(
        `${API_BASE}/Products/${id}`,
        payload
      );

      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);

        navigate(`/product-details/${id}`);
      }, 1500);

    } catch (error) {
      console.error(error);

      alert("Failed to update product");
    }
  };

  // ❌ Cancel / optional old function
  const handleUpdate = () => {
    const storedProducts = JSON.parse(localStorage.getItem("products")) || [];

    const updatedProducts = storedProducts.map((item) =>
      String(item.id) === String(id) ? product : item,
    );

    localStorage.setItem("products", JSON.stringify(updatedProducts));

    navigate("/products");
  };

  return (
    <div className="editproduct-container">
      <Header />

      <div className="editproduct-content">
        {/* HEADER */}
        <div className="editproduct-top">
          <button
            className="editproduct-back-btn"
            onClick={() => navigate("/products")}
          >
            ←
          </button>

          <div>
            <h2>Edit Product</h2>
            <p>Update product information</p>
          </div>
        </div>

        {/* FORM */}
        <div className="editproduct-card">
          {/* PRODUCT NAME */}
          <label className="editproduct-label">Product Name *</label>
          <input
            type="text"
            name="name"
            value={product.name}
            onChange={handleChange}
            className="editproduct-input"
          />

          {/* CATEGORY */}
          <div className="editproduct-row">
            <div>
              <label className="editproduct-label">Category *</label>
              <input
                type="text"
                name="category"
                value={product.category}
                onChange={handleChange}
                className="editproduct-input"
              />
            </div>

            <div>
              <label className="editproduct-label">Subcategory</label>
              <input
                type="text"
                name="subcategory"
                value={product.subcategory}
                onChange={handleChange}
                className="editproduct-input"
              />
            </div>
          </div>

          {/* PRICE */}
          <div className="editproduct-row">
            <div>
              <label className="editproduct-label">Original Price *</label>
              <input
                type="number"
                name="originalPrice"
                value={product.originalPrice}
                onChange={handleChange}
                className="editproduct-input"
              />
            </div>

            <div>
              <label className="editproduct-label">Discount Price</label>
              <input
                type="number"
                name="discountPercentage"
                value={product.discountPercentage}
                onChange={handleChange}
                className="editproduct-input"
              />
            </div>

            <div>
              <label className="editproduct-label">
                Final Price
              </label>

              <input
                type="text"
                value={product.finalPrice}
                readOnly
                className="editproduct-input"
              />
            </div>
          </div>

          {/* DESCRIPTION */}
          <label className="editproduct-label">Description</label>
          <textarea
            name="description"
            value={product.description}
            onChange={handleChange}
            className="editproduct-textarea"
          />

          {/* FABRIC + STOCK */}
          <div className="editproduct-row">
            <div>
              <label className="editproduct-label">Fabric Type</label>
              <input
                type="text"
                name="material"
                value={product.material}
                onChange={handleChange}
                className="editproduct-input"
              />
            </div>

            <div>
              <label className="editproduct-label">Stock</label>
              <input
                type="number"
                name="stock"
                value={product.stock}
                onChange={handleChange}
                className="editproduct-input"
              />
            </div>
          </div>

          {/* IMAGES */}
          <label className="editproduct-label">Product Images</label>

          <label className="editproduct-label">Product Images</label>

          <div className="editproduct-images-row">

            {[0, 1, 2].map((index) => {
              const image = product.images[index];

              return (
                <div key={index} className="image-upload-wrapper">

                  <input
                    type="file"
                    accept="image/*"
                    id={`imageUpload${index}`}
                    hidden
                    onChange={(e) => handleImageUpload(e, index)}
                  />

                  <label
                    htmlFor={`imageUpload${index}`}
                    className="image-upload-box"
                  >
                    {image ? (
                      <img
                        src={image.imageUrl || image}
                        alt="preview"
                        className="editproduct-preview-img"
                      />
                    ) : (
                      <div className="empty-image-box">
                        +
                      </div>
                    )}
                  </label>

                </div>
              );
            })}

          </div>

          {/* STATUS */}
          <label className="editproduct-label">Status</label>

          <select
            name="status"
            value={product.status}
            onChange={handleChange}
            className="editproduct-select"
          >
            <option value={1}>Active</option>
            <option value={2}>Out Of Stock</option>
          </select>

          <hr className="productdetails-divider" />

          {/* BUTTONS */}
          <div className="editproduct-btns">
            <button
              className="editproduct-cancel"
              onClick={() => navigate(`/product-details/${id}`)}
            >
              Cancel
            </button>

            <button className="editproduct-save" onClick={handleSaveClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M12.6667 2.5C13.1063 2.50626 13.5256 2.68598 13.8333 3L17 6.16667C17.314 6.47438 17.4937 6.89372 17.5 7.33333V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H12.6667Z"
                  stroke="white"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.1668 17.5V11.6667C14.1668 11.4457 14.079 11.2337 13.9228 11.0774C13.7665 10.9211 13.5545 10.8333 13.3335 10.8333H6.66683C6.44582 10.8333 6.23385 10.9211 6.07757 11.0774C5.92129 11.2337 5.8335 11.4457 5.8335 11.6667V17.5"
                  stroke="white"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.8335 2.5V5.83333C5.8335 6.05435 5.92129 6.26631 6.07757 6.42259C6.23385 6.57887 6.44582 6.66667 6.66683 6.66667H12.5002"
                  stroke="white"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Save Changes
            </button>
          </div>
        </div>
      </div>

      {/* ✅ POPUP */}
      {showPopup && (
        <div className="editproduct-popup-overlay">
          <div className="editproduct-popup-box">
            <div className="editproduct-popup-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="30px"
                viewBox="0 -960 960 960"
                width="30px"
                fill="#16a34a"
              >
                <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q65 0 123 19t107 53l-58 59q-38-24-81-37.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-18-2-36t-6-35l65-65q11 32 17 66t6 70q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-216L254-466l56-56 114 114 400-401 56 56-456 457Z" />
              </svg>
            </div>

            <h3>Changes Saved Successfully....!</h3>
            <p>Product has been updated.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditProduct;
